import ComponentePaginado from "../ComponentePaginado";
import React, { useState, useEffect, useContext } from "react";
import useTamanhoTela from "../../utils/useTamanhoTela";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavegacaoContext } from "../../contexts/navegacao";
import { ReactComponent as IconeSeta } from "../../assets/icons/expand_more.svg";
import { faBars, faXmark, faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { useMenu } from "../../contexts/menu";
import { useTheme } from "@emotion/react";
import * as S from "./styles";
import { usePermissoesLocalStorage } from "../../utils/usePermissoesLocalStorage";
import { obterStorage } from "../../utils/secureStorage";

const Footer = ({
  caminho = ["exemplo", "exemplo", "exemplo"],
  icon = "iconMenu",
  gerarIcone,
  componenteFlutuante = null,
}) => {
  const visivel = true;

  const ALTURA_FOOTER = 90;
  const { altura } = useTamanhoTela();
  const { verificarPermissao } = usePermissoesLocalStorage();
  const theme = useTheme();
  const [aberto, setAberto] = useState(false);
  const [navegacaoPadrao] = useContext(NavegacaoContext);
  const [navegacao, setNavegacao] = useState(navegacaoPadrao);
  const [listaMenuUtilizavelCopia, setListaMenuUtilizavelCopia] = useState();
  const { listaMenu } = useMenu();
  const [primeiraListagem, setPrimeiraListagem] = useState();
  const [versaoMinima, setVersaoMinima] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const renderMenuComPermissoes = (todosMenus) => {
    if (!todosMenus) return [];

    const sessao = obterStorage("sessao");
    const permissoesWaybe = sessao?.contratoWaybeAtualDTO?.permissoesWaybe;
    const permissoesWaymenu = sessao?.contratoWaymenuAtualDTO?.listaItens;
    const permissoesWaychef = sessao?.contratoWaychefAtualDTO?.listaItens;

    const perfil = sessao?.usuarioLogadoDTO?.usuarioPerfilEmpresaDTO;
    const listaPrivilegios = perfil?.listaPrivilegios;
    const resultado = [];

    for (const item of todosMenus) {
      if (!item) {
        continue;
      }

      if (item["ocultar"]) {
        continue;
      }

      if (item["tipoEmpresa"] != null) {
        const temTipoEmpresa = item["tipoEmpresa"].some(
          (tipo) => tipo === sessao?.empresaDTO.tipoEmpresa,
        );

        if (!temTipoEmpresa) {
          continue;
        }
      }

      if (permissoesWaybe && item["itemContratoWaybe"] != null) {
        const temNoContrato = item["itemContratoWaybe"].every((contrato) =>
          permissoesWaybe.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (permissoesWaychef && item["itemContratoWaychef"] != null) {
        const temNoContrato = item["itemContratoWaychef"].every((contrato) =>
          permissoesWaychef.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (permissoesWaymenu && item["itemContratoWaymenu"] != null) {
        const temNoContrato = item["itemContratoWaymenu"].every((contrato) =>
          permissoesWaymenu.includes(contrato),
        );

        if (!temNoContrato) {
          continue;
        }
      }

      if (listaPrivilegios && item["permissoes"] != null) {
        const nivelNecessario = item["nivelNecessario"];
        const chavePorNivel = {
          EXCLUIR: "excluir",
          ALTERAR: "alterar",
          INSERIR: "inserir",
          CONSULTAR_PERMITIR: "consultar",
        };

        const chavePermissao = nivelNecessario ? chavePorNivel[nivelNecessario] : "consultar";

        const permissoesValidas = item["validarApenasUmaPermissao"]
          ? item["permissoes"].some((perm) => {
              const permissao = verificarPermissao(perm);
              return chavePermissao ? permissao[chavePermissao] : false;
            })
          : item["permissoes"].every((perm) => {
              const permissao = verificarPermissao(perm);
              return chavePermissao ? permissao[chavePermissao] : false;
            });

        if (!permissoesValidas) {
          continue;
        }
      }

      if (item.filhos) {
        const filhosResultado = renderMenuComPermissoes(item.filhos);

        if (filhosResultado.length > 0) {
          resultado.push({ ...item, filhos: filhosResultado });
        } else {
          continue;
        }
      } else {
        resultado.push(item);
      }
    }
    return resultado;
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  useEffect(() => {
    if (!primeiraListagem) {
      setListaMenuUtilizavelCopia();
      setTimeout(() => {
        setListaMenuUtilizavelCopia(renderMenuComPermissoes(listaMenu.menus));
      }, 1000);
    } else {
      setPrimeiraListagem(false);
    }
  }, [listaMenu]);

  useEffect(() => {
    if (listaMenuUtilizavelCopia == undefined) {
      setListaMenuUtilizavelCopia(renderMenuComPermissoes(listaMenu.menus));
    }
  }, [listaMenuUtilizavelCopia]);

  useEffect(() => {
    if (aberto) {
      setNavegacao(navegacaoPadrao);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [aberto]);

  useEffect(() => {
    if (!visivel) setAberto(true);
  }, [visivel]);

  useEffect(() => {
    if (componenteFlutuante != null) {
      const handleScroll = () => {
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        const isBottom = windowHeight + scrollTop >= documentHeight - 100;
        setIsAtBottom(isBottom);
      };

      window.addEventListener("scroll", handleScroll);
      handleScroll();

      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  function Corpo() {
    return (
      listaMenuUtilizavelCopia != undefined && (
        <>
          <S.OverlayFechar
            onClick={() => setAberto(!aberto)}
            style={{
              opacity: aberto ? 1 : 0,
              visibility: aberto ? "visible" : "hidden",
            }}
          />

          <S.ContainerBottomSheetNavegacao
            style={{
              paddingBottom: ALTURA_FOOTER + "px",
              overflow: "scroll",
              height: `${altura - 120}px`,
              bottom: aberto
                ? 0
                : -1 * (170 * Object.keys(navegacao).length - 1 + ALTURA_FOOTER) + "px",
              left: "0",
              transition: "bottom 0.45s ease-out",
            }}
          >
            <ComponentePaginado
              Filho={S.BotaoNavegacao}
              Separador={S.Separador}
              navegacaoInicial={listaMenuUtilizavelCopia}
              mobile
            />
          </S.ContainerBottomSheetNavegacao>
          {ConteudoFooter()}
        </>
      )
    );
  }

  function Caminho() {
    const caminhoGerado = [];

    for (let i = 0; i < caminho.length; i++) {
      caminhoGerado.push(
        <S.CaminhoLinha key={caminho[i] + i}>
          <p>{caminho[i]}</p>{" "}
          {i !== caminho.length - 1 && (
            <IconeSeta
              fill={theme.cores.textoSimples}
              style={{
                transform: "rotate(270deg)",
                marginLeft: "6px",
                marginRight: "6px",
              }}
            />
          )}
        </S.CaminhoLinha>,
      );
    }
    return <S.ContainerCaminho>{caminhoGerado}</S.ContainerCaminho>;
  }

  function ConteudoFooter() {
    return (
      <S.Container
        style={{
          height: versaoMinima ? "40px" : "70px",
        }}
        icon={"iconMenu"}
      >
        {componenteFlutuante != null && !isAtBottom && (
          <S.ContainerBotaoFlutuante
            style={{
              bottom: versaoMinima ? "50px" : "80px",
            }}
          >
            {componenteFlutuante}
          </S.ContainerBotaoFlutuante>
        )}

        <S.ContainerIconeExpandir onClick={() => setVersaoMinima((prev) => !prev)}>
          <FontAwesomeIcon
            style={{
              marginRight: "6px",
              fontSize: "1.1em",
              position: "absolute",
              right: "5px",
              color: theme.cores.actionActive,
            }}
            icon={versaoMinima ? faChevronDown : faChevronUp}
          />
        </S.ContainerIconeExpandir>

        <S.ContainerRecortarCirculo onClick={() => setAberto(!aberto)}>
          <S.RecorteCirculo
            style={{
              width: versaoMinima ? "55px" : "70px",
              height: versaoMinima ? "55px" : "70px",
              left: versaoMinima ? "calc(50% - 24px)" : "calc(50% - 35px)",
            }}
          />
        </S.ContainerRecortarCirculo>

        <S.ContainerIcone
          style={{
            width: versaoMinima ? "40px" : "56px",
            height: versaoMinima ? "40px" : "56px",
            left: versaoMinima ? "calc(50% - 15px)" : "calc(50% - 28px)",
          }}
          onClick={() => setAberto(!aberto)}
        >
          {!aberto ? (
            <FontAwesomeIcon
              icon={faBars}
              style={{
                width: versaoMinima ? 20 : 27,
                height: versaoMinima ? 20 : 27,
                color: theme.cores.actionActive,
              }}
            />
          ) : (
            <FontAwesomeIcon
              icon={faXmark}
              style={{
                width: versaoMinima ? 20 : 30,
                height: versaoMinima ? 20 : 30,
                color: theme.cores.actionActive,
              }}
            />
          )}
        </S.ContainerIcone>

        {!versaoMinima && <Caminho />}
      </S.Container>
    );
  }

  return Corpo();
};

export default Footer;
